var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('lottie-player',{staticClass:"lottie",attrs:{"src":"/images/icons/pending.json","autoplay":"","loop":""}}),_c('h1',[_vm._v(" Waitting For Admin to Verify Your ID ..... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }